import en from './languages/en';

export default { en };



// WEBPACK FOOTER //
// ./src/constants/content/index.js